import { i18nLangOfGame } from 'locale/i18n';
import { IS_EDITOR_MODE } from 'config/envVariable';
import { COVER_PAGE, SUCCESS_PAGE, FAIL_PAGE } from 'components/MemoryMatch/Core/constants/pages';

// 版面設定
export const ROW_ITEMS_MAXIMUM_PC = 6;
export const ROW_ITEMS_MAXIMUM_MOBILE = 4;

// 卡片比例
export const RATIO_SQUARE = 'square';
export const RATIO_RECT = 'rect';

export const ratioValueMapping = {
    [RATIO_SQUARE]: 1 / 1,
    [RATIO_RECT]: 3 / 4
};

// 0: 直接開始玩不給看的拉
// 5: 先預覽答案 5 秒才開始玩 (目前先 fixed)
export const PREVIEW_MINIMUM_TIME_LIMIT = 0;
export const PREVIEW_MAXIMUM_TIME_LIMIT = 5;

// 錯誤次數上限
// 1 ~ 30: 限制次數
export const FAILURE_MAXIMUM_TIMES_LIMIT = 30;
export const FAILURE_MINIMUM_TIMES_LIMIT = 1;

// 遊戲時間的上限為 10 分 0 秒: 10 * 60
// 以秒數為單位來儲存資料
// > 0: 正常倒數
export const MAXIMUM_MINUTES_TIME_LIMIT = 10;
export const MAXIMUM_SECONDS_TIME_LIMIT = 59;
export const MAXIMUM_TIME_LIMIT = MAXIMUM_MINUTES_TIME_LIMIT * 60;
export const MINIMUM_TIME_LIMIT = 1;

// createdAt => 參加時間新到舊排序
// timeSpent => 翻牌花費時間由少到多
export const RECORD_SORT_BY_CREATED_AT = 'createdAt';
export const RECORD_SORT_BY_TIME_SPENT = 'timeSpent';

// 不限制時的值 (共用、統一來源)
export const UNLIMIT_VALUE = 0;

// 結果頁依 playOnce=0 出現再玩一次按鈕；playOnce = 1 則不出現（相同 Entry 只能挑戰一次）
export const CAN_PLAY_ONCE = 1;
export const CAN_REPLAY = 0;

export const defaultGameSetting = (isEditor =>
    isEditor
        ? {
              // int: 1 | 2 | 3 | 4 | 5 | 6
              rowItemsPC: 3,
              // int: 1 | 2 | 3 | 4
              rowItemsMobile: 2,
              // String: URL
              cardBack: 'https://assets.fevercdn.com/promotion/img/memoryMatch_cardBack.jpg',
              // String: 'square' | 'rect'
              ratio: RATIO_SQUARE,
              // int: 0 | 5
              previewTimeLimit: PREVIEW_MINIMUM_TIME_LIMIT,
              // int: 1 ~ 30
              // 1 ~ 30: 限制次數
              failureTimesLimit: 10,
              // as second, dynamically
              // = 0: 無限
              // > 0: 正常倒數
              timeLimit: 120,
              // Bool: 0 | 1
              playOnce: CAN_REPLAY,
              // createdAt => 參加時間新到舊排序
              // timeSpent => 翻牌花費時間由少到多
              recordSort: RECORD_SORT_BY_CREATED_AT,
              [COVER_PAGE]: {
                  // Bool: 0 | 1
                  isShowButton: 1,
                  // Bool: 0 | 1
                  isShowTitle: 1,
                  // String
                  title: i18nLangOfGame.t('label.memory_match.cover_page.title'),
                  // String: URL
                  bgImage: 'https://assets.fevercdn.com/promotion/img/memoryMatch_coverPage_bg.jpg'
              },
              [SUCCESS_PAGE]: {
                  // String
                  title: i18nLangOfGame.t('label.memory_match.success_page.title'),
                  // String: URL
                  bgImage:
                      'https://assets.fevercdn.com/promotion/img/memoryMatch_successPage_bg.jpg'
              },
              [FAIL_PAGE]: {
                  // String
                  title: i18nLangOfGame.t('label.memory_match.fail_page.title'),
                  // String: URL
                  bgImage: 'https://assets.fevercdn.com/promotion/img/memoryMatch_failPage_bg.jpg'
              }
          }
        : {})(IS_EDITOR_MODE);
